import { render, staticRenderFns } from "./LiveStreamAction.vue?vue&type=template&id=2c6f87f5&scoped=true"
import script from "./LiveStreamAction.vue?vue&type=script&lang=js"
export * from "./LiveStreamAction.vue?vue&type=script&lang=js"
import style0 from "./LiveStreamAction.vue?vue&type=style&index=0&id=2c6f87f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f87f5",
  null
  
)

export default component.exports